<!--suppress JSNonASCIINames -->
<template>
  <vx-card>
    <div>
      <div class="flex justify-between items-center">
        <p style="font-size: 18px; font-weight: 700">터널</p>
        <div class="flex justify-end">
          <vs-button class="ml-4" color="secondary" type="border" @click.stop.prevent="onClickDownloadExcel">엑셀(FMS) 내려받기</vs-button>
          <vs-button v-if="isEditable && !!fieldId" class="ml-4" color="secondary" type="border" @click="onClickDelete">삭제</vs-button>
          <vs-button class="ml-4" color="secondary" type="border" @click="onClickMoveList">목록</vs-button>
          <vs-button v-if="isEditable" class="ml-4" color="secondary" @click="onClickSave">저장</vs-button>
        </div>
      </div>

      <!-- 기본정보 -->
      <div class="mt-28px">
        <h5 class="mb-4"><i class="dot"></i> 기본정보</h5>
        <div class="writeGridContainer">
          <div>
            <div>관리주체</div>
            <ml-input readonly v-model="form.management_entity"/>
          </div>
          <div>
            <div>소유자</div>
            <ml-input readonly v-model="form.owner"/>
          </div>
          <div>
            <div>전화번호</div>
            <ml-input v-model="form.phoneNumber" :readonly="readonly"/>
          </div>
          <div>
            <div>보관자</div>
            <ml-input v-model="form.custodian" :readonly="readonly"/>
          </div>
          <div>
            <div>관리방법</div>
            <vs-select autocomplete v-model="form.관리방법">
              <vs-select-item text="직접관리" value="직접관리" />
              <vs-select-item text="위탁관리" value="위탁관리" />
            </vs-select>
          </div>
          <div>
            <div>소관부서</div>
            <ml-input v-model="form.소관부서" :readonly="readonly" />
          </div>
          <div>
            <div>담당주무관</div>
            <ml-input v-model="form.담당주무관" :readonly="readonly" />
          </div>
        </div>
      </div>
    </div>

    <!-- 시설물 정보 -->
    <tunnel-write-body :form="form" :category-info="categoryInfo" :readonly="readonly" />

    <!-- 관리 부서 및 업체 등록 -->
    <company-add-module
      title="관리 부서 및 업체 등록"
      :tableColumns="[
        { head: '구분', key: 'com_type' },
        { head: '부서(업체)명', key: 'com_name' },
        { head: '연락처', key: 'phone' },
      ]"
      :isSimple="true"
      v-model="companyList"
      @remove="removeCompany"
      :readonly="readonly"
    />

    <!-- 전경사진 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" section-title="전경사진"
                              placeholder="전경사진" :readonly="readonly"/>

    <file-upload-module v-model="fileList" class="mt-28px" :readonly="readonly" target="field"/>
  </vx-card>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import CompanyAddModule from "@/views/_BS/components/CompanyAddModule";
import DateSelector from "@/components/selector/DateSelector";
import DateSelectorRang from "@/components/selector/DateSelectorRang";
import SignField from "@/components/SignField.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import moment from "moment";
import FileUploader from "@/components/FileUploader.vue";
import TableCustom from "@/components/TableCustom.vue";
import TunnelWriteBody from "@/views/fields/single-page/tunnel/TunnelWriteBody.vue";
import PortWriteBody from "@/views/fields/single-page/port/PortWriteBody.vue";
import ExcelJS from "exceljs";

export default {
  components: {
    PortWriteBody,
    TunnelWriteBody,
    TableCustom,
    FileUploader,
    FileUploadModule,
    CompanyAddModule,
    DateSelector,
    DateSelectorRang,
    SignField,
    PhotoUploadGridModule,
  },
  data() {
    return {
      form: {
        phoneNumber: "",
        custodian: "",
        관리방법: "직접관리",
        소관부서: "",
        담당주무관: "",

        facilityNumber: "",
        managementNumber: "",
        facilityName: "",
        routeDivision: "",
        routeDetail: "",

        facility_category_id: "",
        cat1: "",
        cat2: "",
        cat3: "",
        classification: "",

        socEvaluationTarget: "",
        address: "",
        management_entity: "",
        management_type: "",
        owner: "",
        ownerType: "",
        businessPlanApprovalDate: "",
        completionDate: "",
        defectLiabilityExpirationDate1: "",
        detailedSpecifications: "",
        safetyInspectionAndDiagnosisHistory: "",
        repairAndReinforcementHistory: "",
        accessibleVentCover: "",
        designPeriod: {sDate: "", eDate: ""},
        designer: "",
        defectLiabilityExpirationDate2: "",
        constructionPeriod: {sDate: "", eDate: ""},
        contractor: "",
        totalConstructionCost: "",
        seismicDesignTarget: "",
        seismicDesignApplication: "",
        seismicDesignStandard: "",
        seismicPerformanceEvaluation: "",
        seismicReinforcement: "",
        young21Target: "",
        auditPeriod: {sDate: "", eDate: ""},
        auditor: "",
        projectOwner: "",
        constructionName: "",
        defectLiabilityExpirationDate: "",
        constructionSupervisor: "",
        creationDate: moment().format("YYYY-MM-DD"),
        author: this.$store.state.auth.userInfo ? this.$store.state.auth.userInfo.name : "",
        signature: "",
        lastModifiedDate: "",
        lastModifiedBy: "",
        remarks: "",

        // 상세제원(터널)
        터널시점위치: "",
        터널종점위치: "",
        폭_보도: "",
        폭_차도: "",
        계: "",
        연장: "",
        높이: "",
        형상_대표: "",
        주요공법_대표: "",
        보조공법_대표: "",
        배수형식_대표: "",
        갱문형식_대표: "",
        형상_기타: "",
        주요공법_기타: "",
        보조공법_기타: "",
        배수형식_기타: "",
        갱문형식_기타: "",
        구조형식: "",
        덕트슬래브: "",
        인버트설치: "",
        차로수_상행: "",
        차로수_하행: "",
        종단기울기: "",
        평면선형곡선반경R: "",
        부속설비_조명: "",
        부속설비_전기: "",
        부속설비_소방설비: "",
        부속설비_기타: "",
        표준단면도_1: {},
        표준단면도_2: {},
        표준단면도_3: {},
        자연환기1: "",
        강제환기_종류식1: "",
        강제환기_횡류식1: "",
        강제환기_반횡류식1: "",
        자연환기2: "",
        강제환기_종류식2: "",
        강제환기_횡류식2: "",
        강제환기_반횡류식2: "",
        구간정보: [
          {시점: "", 종점: "", 표준패턴: ""},
          {시점: "", 종점: "", 표준패턴: ""},
        ],

        otherSpecifications: "",

        companyList: [],
        photoList: [],
      },

      companyList: [],
      userList: [],
      joinUsers: [],
      fileList: [],

      catLock: true,
      categoryInfo: {
        facility_category_id: 0,
        cat1: "",
        cat2: "",
        cat3: "",
        classification: "",
      },
    };
  },
  computed: {
    projectId() {
      return Number(this.$route.params.proj_id);
    },
    fieldId() {
      return this.$route.params.fieldId;
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    /**
     * 현재 사용자가 프로젝트 관리자인지 확인합니다.
     * 프로젝트 관리자는 사업장을 등록/수정/삭제할 수 있습니다.
     * @returns {boolean}
     */
    isProjectManager() {
      const memberInfo = this.$store.state.member.memberInfo;
      if (memberInfo) {
        if (memberInfo.is_superuser) {
          return true;
        }

        const projects = memberInfo.projects;
        if (projects && projects.length > 0) {
          for (const project of projects) {
            if (`${project.id}` === `${this.projectId}`) {
              return project.pivot.is_manager;
            }
          }
        }
      }
      return false;
    },
    /**
     * 사업장을 프로젝트 관리자만 수정할 수 있는지 확인합니다.
     * @returns {boolean}
     */
    isFieldEditByManagerOnly() {
      const projectInfo = this.$store.state.project.projectInfo;

      return !!projectInfo.field_edit_by_manager_only;
    },
    isEditable() {
      if (this.isFieldEditByManagerOnly) {
        return this.isProjectManager;
      }
      return true;
    },
    readonly() {
      return !this.isEditable;
    },
  },
  watch: {
    async companyList() {
      await this.initMembers();
    },
  },
  async created() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
  },
  async mounted() {
    if (this.fieldId) {
      await this.loadField();
    }
  },
  methods: {
    async loadField() {
      const fieldId = this.fieldId;
      await this.$store.dispatch("project/LOAD_FIELD", {fieldId});
      const info = this.$store.state.project.fieldInfo;

      this.joinUsers = info.users;
      this.form = {...this.form, ...info, ...JSON.parse(info.meta)};

      if (info.facility_category) {
        this.form.facility_category_id = info.facility_category.id;
        this.form.cat1 = info.facility_category.cat1;
        this.form.cat2 = info.facility_category.cat2;
        this.form.cat3 = info.facility_category.cat3;
        this.form.classification = info.facility_category.classification;

        this.categoryInfo = {
          facility_category_id: info.facility_category.id,
          cat1: info.facility_category.cat1,
          cat2: info.facility_category.cat2,
          cat3: info.facility_category.cat3,
          classification: info.facility_category.classification,
        };
      }

      // 첨부파일
      this.form.fileList = info.attachments || [];

      // this.form.photoList 항목이 2개보다 적을 경우, 빈 항목을 추가한다.
      if (this.form.photoList.length < 2) {
        for (let i = this.form.photoList.length; i < 2; i++) {
          this.form.photoList.push({ id: "", url: "" });
        }
      }

      if (this.form.companies && info.companies.length > 0) {
        const companies = [];
        for (const company of info.companies) {
          companies.push(company);
        }
        this.companyList = companies;

        await this.initMembers();
      }

      if (this.form.fileList) {
        this.fileList = this.form.fileList;
      }
    },

    async initMembers() {
      const joinUsers = this.joinUsers;
      const members = [];
      for (const company of this.companyList) {
        members.push(...(await this.loadMember(company.id)));
      }

      for (const member of members) {
        let join_project = false;
        for (const user of joinUsers) {
          if (user.id === member.id) {
            join_project = true;
            break;
          }
        }
        member.join_project = join_project;
      }

      this.userList = members;
    },

    async loadMember(company_id) {
      const page = 1;
      const perPage = 100;
      await this.$store.dispatch("company/LOAD_MEMBER_LIST", {page, perPage, company_id});
      return JSON.parse(JSON.stringify(this.$store.state.company.memberList));
    },

    removeCompany(company) {
      let i = 0;
      for (i = 0; i < this.joinUsers.length; i++) {
        const usr = this.joinUsers[i];
        if (usr.company_id === company.id) {
          this.joinUsers.splice(i, 1);
          i--;
        }
      }
    },

    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: title ? title : "오류가 발생했습니다",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },

    onClickSave() {
      // 필수 : facilityNumber, facilityName,
      if (!this.form.facilityNumber) {
        this.customAlert("시설물 번호를 입력해주세요.");
        return;
      }
      if (!this.form.facilityName) {
        this.customAlert("시설물명을 입력해주세요.");
        return;
      }

      const option = {
        project_id: this.projectId, // 프로젝트 ID
        field_name: this.form.facilityName, // 현장(시설물, 사업장) 이름
        contract_code: this.form.facilityNumber, // 계약번호
        address: this.form.address, // 주소
        phone: this.form.phoneNumber, // 대표번호
        be_completed_at: this.form.completionDate, // 준공일
        deposit_amount: this.form.totalConstructionCost, // 총공사비
        facility_category_id: this.form.facility_category_id, // Category
        uploads: this.fileList.map((file) => file.id), // 파일
      };

      const company_ids = [];
      for (const com of this.companyList) {
        company_ids.push(com.id);
      }
      const user_ids = [];
      if (this.joinUsers.length > 0) {
        for (const user of this.joinUsers) {
          user_ids.push(user.id);
        }
      }
      option.company_ids = company_ids;
      option.user_ids = user_ids;

      // Meta
      option.meta = {...this.form, lastModifiedDate: moment().format("YYYY-MM-DD"), lastModifiedBy: this.myInfo.name};

      this.$emit('save', option)
    },
    onClickDelete() {
      this.$emit('delete', this.fieldId)
    },
    onClickMoveList() {
      this.$emit('moveList')
    },
    async onClickDownloadExcel() {
      // 엑셀 파일 가져오기
      // 파일은 public/fms/ 경로에 저장되어 있다.
      const response = await fetch('/fms/시설물관리대장_터널.xlsx');
      const arrayBuffer = await response.arrayBuffer();

      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);

      // 첫번째 시트의 이름 가져오기
      const worksheet = workbook.worksheets[0];

      // 시트에 데이터 입력하기
      this.applyDataToSheet(worksheet);

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      let fileName = '';
      if (this.form.facilityName) {
        if (this.form.facilityNumber) {
          fileName = `시설물관리대장_${this.form.facilityName}_${this.form.facilityNumber}`;
        } else {
          fileName = `시설물관리대장_${this.form.facilityName}`;
        }
      } else if (this.form.facilityNumber) {
        fileName = `시설물관리대장_${this.form.facilityNumber}`;
      } else {
        fileName = `시설물관리대장`;
      }
      fileName += '.xlsx';

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    },
    applyDataToSheet(worksheet) {
      const cellMatchInfo = {
        facilityNumber: ['AA4', 'BL13'],  // 시설물번호
        managementNumber: ['AA5', 'K20'], // 관리번호
        facilityName: ['AA6', 'S20', 'B42'], // 시설물명
        management_entity: ['Y13', 'V22'], // 관리주체
        owner: ['Y14'], // 소유자
        custodian: ['Y15'], // 보관자
        routeDivision: ['AD20'], // 노선-구분
        routeDetail: ['AI20'], // 노선-세부노선
        cat1: ['AZ20'], // 시설물구분
        cat3: ['AO20'], // 시설물종류
        classification: ['AT20'],  // 시설물종별
        socEvaluationTarget: ['BE20'], // SOC성능평가대상
        address: ['B22'], // 주소
        businessPlanApprovalDate: ['B27'], // 사업계획승인일
        completionDate: ['H27'], // 준공일
        defectLiabilityExpirationDate1: ['R27'], // 하자보수보증종료일
        detailedSpecifications: ['X27'], // 상세제원
        safetyInspectionAndDiagnosisHistory: ['AC27'], // 안전점검진단이력
        repairAndReinforcementHistory: ['AJ27'], // 보수보강이력
        accessibleVentCover: ['AQ27'], // 통풍구방법
        designer: ['T29'], // 설계자
        contractor: ['AP29'], // 시공자
        totalConstructionCost: ['BB29'], // 총공사비
        seismicDesignTarget: ['G31'], // 지진설계대상
        seismicDesignApplication: ['T31'], // 지진설계적용
        seismicDesignStandard: ['AE31'], // 지진설계기준
        seismicPerformanceEvaluation: ['AP31'], // 지진성능평가
        seismicReinforcement: ['BB31'], // 지진보강
        young21Target: ['B33'], // 영21조대상
        auditor: ['T33'], // 감리자
        projectOwner: ['AE33'], // 사업주체
        constructionName: ['AP33'], // 공사명
        constructionSupervisor: ['BB33'], // 공사감독
        creationDate: ['B36'], // 작성일
        lastModifiedDate: ['AF36'], // 최종 수정일
        lastModifiedBy: ['AU36'], // 최종 수정자
        remarks: ['F37'], // 비고

        // 상세제원
        터널시점위치: ['M42'], // 터널시점위치
        터널종점위치: ['Z42'], // 터널종점위치
        폭_보도: ['AM42'], // 폭_보도
        폭_차도: ['AQ42'], // 폭_차도
        계: ['AV42'], // 계
        연장: ['BC42'], // 연장
        높이: ['BF42'], // 높이

        형상_대표: ['D45'], // 형상_대표
        주요공법_대표: ['M45'], // 주요공법_대표
        보조공법_대표: ['AB45'], // 보조공법_대표
        배수형식_대표: ['AQ45'], // 배수형식_대표
        갱문형식_대표: ['BC45'], // 갱문형식_대표

        형상_기타: ['D46'], // 형상_기타
        주요공법_기타: ['M46'], // 주요공법_기타
        보조공법_기타: ['AB46'], // 보조공법_기타
        배수형식_기타: ['AQ46'], // 배수형식_기타
        갱문형식_기타: ['BC46'], // 갱문형식_기타

        구조형식: ['B49'], // 구조형식
        덕트슬래브: ['M49'], // 덕트슬래브
        인버트설치: ['U49'], // 인버트설치
        차로수_상행: ['AB49'], // 차로수_상행
        차로수_하행: ['AH49'], // 차로수_하행
        종단기울기: ['AQ49'], // 종단기울기
        평면선형곡선반경R: ['BC49'], // 평면선형곡선반경R

        부속설비_조명: ['AL53'], // 부속설비_조명
        부속설비_전기: ['AS53'], // 부속설비_전기
        부속설비_소방설비: ['AY53'], // 부속설비_소방설비
        부속설비_기타: ['BE53'], // 부속설비_기타

        자연환기1: ['H53'], // 자연환기1
        강제환기_종류식1: ['R53'], // 강제환기_종류식1
        강제환기_횡류식1: ['W53'], // 강제환기_횡류식1
        강제환기_반횡류식1: ['AD53'], // 강제환기_반횡류식1

        otherSpecifications: ['L56', 'N59'],  // 기타제원
      };


      for (const key in cellMatchInfo) {
        const cell = cellMatchInfo[key];
        for (const c of cell) {
          worksheet.getCell(c).value = this.form[key] ? this.form[key] : '';
        }
      }


      worksheet.getCell('AC25').value = '';
      worksheet.getCell('AG25').value = '';
      worksheet.getCell('AK25').value = '';
      worksheet.getCell('AO23').value = '';
      if (this.form.management_type === '중앙부처') {
        worksheet.getCell('AC25').value = 'V';
      } else if (this.form.management_type === '지자체') {
        worksheet.getCell('AG25').value = 'V';
      } else if (this.form.management_type === '(국가/지방)공기업') {
        worksheet.getCell('AK25').value = 'V';
      } else if (this.form.management_type === '민간') {
        worksheet.getCell('AO23').value = 'V';
      }

      worksheet.getCell('AW25').value = '';
      worksheet.getCell('BC25').value = '';
      worksheet.getCell('BD25').value = '';
      worksheet.getCell('BG23').value = '';
      if (this.form.ownerType === '중앙부처') {
        worksheet.getCell('AW25').value = 'V';
      } else if (this.form.ownerType === '지자체') {
        worksheet.getCell('BC25').value = 'V';
      } else if (this.form.ownerType === '(국가/지방)공기업') {
        worksheet.getCell('BD25').value = 'V';
      } else if (this.form.ownerType === '민간') {
        worksheet.getCell('BG23').value = 'V';
      }

      // 전화번호
      worksheet.getCell('AN14').value = `전화번호: ${this.form.phoneNumber}`;

      // 첨부자료 목록
      const fileNames = this.fileList.map((file) => file.originalName).join(', ');
      worksheet.getCell('AX27').value = fileNames;

      // 설계기간
      worksheet.getCell('B29').value = `${this.form.designPeriod.sDate  } ~ ${  this.form.designPeriod.eDate}`;

      // 공시기간
      worksheet.getCell('AE29').value = `${this.form.constructionPeriod.sDate  } ~ ${  this.form.constructionPeriod.eDate}`;

      // 감리기간
      worksheet.getCell('G33').value = `${this.form.auditPeriod.sDate  } ~ ${  this.form.auditPeriod.eDate}`;

      // 작성자
      worksheet.getCell('P36').value = `${this.form.author }  (인)`;

      // 차로수 계
      worksheet.getCell('AM49').value = parseInt(this.form.차로수_상행 || '0') + parseInt(this.form.차로수_하행 || '0');

      // 구간정보
      const sectionInfo = this.form.구간정보 || [];
      for (let i = 0; i < 14; i++) {
        // 빈 칸으로 초기화한다
        worksheet.getCell(`B${63 + i}`).value = '';
        worksheet.getCell(`W${63 + i}`).value = '';
        worksheet.getCell(`AS${63 + i}`).value = '';
      }
      for (let i = 0; i < sectionInfo.length; i++) {
        const section = sectionInfo[i];
        worksheet.getCell(`B${63 + i}`).value = section.시점;
        worksheet.getCell(`W${63 + i}`).value = section.종점;
        worksheet.getCell(`AS${63 + i}`).value = section.표준패턴;
      }

      // 빈칸으로 만들 칸들
      const emptyCells = ['E22', 'I22', 'Q22', 'Q24', 'M43', 'Z43'];
      for (const cell of emptyCells) {
        worksheet.getCell(cell).value = '';
      }
    }
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 5px;
  }

  th {
    background: #f9f9f9;
    padding: 10px 4px;
  }
}
</style>
<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.size-search {
  width: 200px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 0;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
